import { FilterSearchModel } from 'app/area/search-filters/types-store';
import { ModifiedImportMappings, CodeListItem, CodetableMetadata, ImportMappingsListState } from './types-store';

export const getCodetableMetadata = (metadata: CodetableMetadata, codetableId: number): CodetableMetadata =>
  !!metadata && !!metadata.code && metadata.code.id === codetableId ? metadata : undefined;

export const compareStateWithRequestedProps =
  (state: ImportMappingsListState, codetableId: number, categoryId: number, model: FilterSearchModel) =>
    (state ? codetableId === state.fetchingCodetableId : codetableId === undefined) &&
    (state && state.category ? categoryId === state.category.value : categoryId === undefined) &&
    (state && state.requestedSearchModel ? state.requestedSearchModel === model : model === undefined);

export const compareImportMappingIds = (modified: ModifiedImportMappings, persisted: CodeListItem) =>
  modified.id === persisted.id;

export const getModifiedItem = (modifiedItems: ModifiedImportMappings[], persistedItem: CodeListItem) =>
  !modifiedItems || !persistedItem
    ? undefined
    : modifiedItems.find(
      modifiedItem => compareImportMappingIds(modifiedItem, persistedItem)
    );

export const findModifiedItem = (modifiedItems: ModifiedImportMappings[], modifiedItem: ModifiedImportMappings) =>
  !modifiedItems || !modifiedItem
    ? undefined
    : modifiedItems.find(item =>
      item.id === modifiedItem.id &&
      item.codetable === modifiedItem.codetable
    );
